import { View, Image, Text, StyleSheet, TouchableOpacity, Dimensions } from 'react-native'
import { Platform } from 'react-native'
import { useWindowDimensions } from 'react-native'
import { useNavigation } from '../../hooks/useWebNavigation'
import RenderHTML from 'react-native-render-html'
import { LEARNING_STATUS, OPTIONS } from './constants'
import theme from '../../../theme'
import Styles from './CourseItemStyles'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { useEffect, useState } from 'react'
import { deepJSONParse, getNameUrl, searchFilebyName } from '../../utils/functions.utils'
import { getReprobatedText } from './hooks/getReprobatedText'
import { useLearningStore } from '../../../src/redux/zustand/useLearningCourse.ts'
import { normalizeCourse } from './CourseHome'

const { width } = Dimensions.get('window')
const { height } = Dimensions.get('screen')

const statusColors = {
    [LEARNING_STATUS.BLOCKED]: theme.colors.colorLocked,
    [LEARNING_STATUS.PENDIENTE]: theme.colors.colorPending,
    [LEARNING_STATUS.VIEWED]: theme.colors.colorSeen,
    [LEARNING_STATUS.COMPLETED]: theme.colors.colorApproved,
    [LEARNING_STATUS.REPROBADO]: theme.colors.colorRetry,
    [LEARNING_STATUS.PENDING_CONNECTION]: theme.colors.colorPending,
    [LEARNING_STATUS.IN_PROGRESS]: theme.colors.colorInProgress,
}

export const CourseItem = ({ item, category_blocked, array_cursos, horizontal, isMobile }) => {
    const [contentDownloaded, setContentDownloaded] = useState(false)
    const get_curso = item
    const { width: winWidth } = useWindowDimensions()
    const [curso, setCurso] = useState(get_curso)
    const clearCourse_store = useLearningStore(state => state.clearCourse)
    

    const { languageFile } = getLanguage()

    const STATUS = category_blocked ? LEARNING_STATUS.BLOCKED : item.status

    const navigation = useNavigation()

    let path = `courses/${curso._id}`

    const handle_course = () => {

        clearCourse_store()

        const shouldNavigateToSurvey = checkIfShouldNavigateToSurvey(item)

        if (shouldNavigateToSurvey) {
            navigateToSurvey(item)
            return 
        }

        const params = {
            item: item,
            array_cursos: array_cursos,
        }

        navigation.navigate('Course', params)
    }

    const navigateToSurvey = (course) => {
        console.log('[CourseItem] Navigating to Survey for course:', course._id)

        const normalizedCourse = normalizeCourse(course)

        navigation.navigate('Survey', {
            evaluation: normalizedCourse.evaluations,
            next_content: null,
            current_modul: {},
            option: OPTIONS.OPTION_COURSE,
            course_id: course._id,
            courseItem: normalizedCourse,
        })
    }

    const checkIfShouldNavigateToSurvey = (course) => {
        const modules = deepJSONParse(course.moduls) || []
        const contents = deepJSONParse(course.contents) || []
        const evaluations = deepJSONParse(course.evaluations) || []

        const hasNoModules = modules.length === 0
        const hasNoContents = contents.length === 0
        const hasEvaluations = evaluations.length > 0

        console.log('[CourseItem] Navigation check:', {
            hasNoModules,
            hasNoContents,
            hasEvaluations,
            shouldNavigateToSurvey: hasNoModules && hasNoContents && hasEvaluations,
        })

        return hasNoModules && hasNoContents && hasEvaluations
    }

    useEffect(() => {
        const checkContentDownloaded = async () => {
            let contents = await curso.moduls.flatMap((modulo) => {
                let contents2 = modulo.media_slides.flatMap((item) => {
                    return item.media
                })
                return contents2
            })

            if (contents.length > 0) {
                if (Platform.OS === 'web') {
                    setContentDownloaded(false)
                    return
                }
                const ImageName = getNameUrl(contents[0])
                const exist = await searchFilebyName(ImageName, 'unzipped/' + path)

                if (!exist) {
                    // console.log('Archivo no encontrado.')
                    setContentDownloaded(false)
                    return
                }

                console.log('Archivo encontrado.')
                setContentDownloaded(true)
            }
        }
        checkContentDownloaded()
    }, [curso])

    const set_status_label = () => {
        let label_text = ''

        switch (STATUS) {
            case LEARNING_STATUS.BLOCKED:
                label_text = languageFile.locked
                break
            case LEARNING_STATUS.PENDIENTE:
                label_text = languageFile.pending
                break
            case LEARNING_STATUS.VIEWED:
                label_text = languageFile.seen
                break
            case LEARNING_STATUS.COMPLETED:
                label_text = languageFile.complete
                break
            case LEARNING_STATUS.REPROBADO:
                label_text = getReprobatedText()
                break
            case LEARNING_STATUS.PENDING_CONNECTION:
                label_text = languageFile.sync_pend
                break
            case LEARNING_STATUS.IN_PROGRESS:
                label_text = languageFile.in_progress
                break
            default:
                label_text = languageFile.pending
                break
        }

        return label_text.toUpperCase()
    }

    if (horizontal) {
        if (isMobile) {
            return (
                <View style={[Styles.container, { opacity: STATUS === LEARNING_STATUS.BLOCKED ? 0.5 : 1 }, !isMobile && { width: 280 }]}>
                    <TouchableOpacity
                        onPress={handle_course}
                        style={[Styles.itemCourse, STATUS === LEARNING_STATUS.BLOCKED && Styles.block_content, !isMobile && { marginLeft: 16 }]}
                        disabled={STATUS === LEARNING_STATUS.BLOCKED ? true : false}
                    >
                        <View>
                            {contentDownloaded && (
                                <View style={Styles.containerCloudCheck}>
                                    <Image
                                        style={{ width: 24, height: 24 }}
                                        tintColor={theme.colors.colorApproved}
                                        source={require('../../../assets/cloudCheck.png')}
                                    />
                                </View>
                            )}
                            <Image
                                style={Styles.imageCourse}
                                source={{
                                    uri: item.cover_image
                                        ? item.cover_image
                                        : 'https://resources-one.s3.us-east-2.amazonaws.com/sky/contents/assets/faltante.png',
                                }}
                            />
                        </View>

                        <View
                            style={[
                                Styles.statusModuleList,
                                {
                                    backgroundColor:
                                        STATUS != LEARNING_STATUS.BLOCKED ? statusColors[STATUS] : 'transparent' || theme.colors.colorLocked,
                                    borderColor: STATUS === LEARNING_STATUS.BLOCKED ? theme.colors.colorLocked : 'transparent',
                                },
                            ]}
                        >
                            <Text
                                style={[
                                    Styles.statusModuleText,
                                    {
                                        color: STATUS === LEARNING_STATUS.BLOCKED ? theme.colors.colorLocked : 'white',
                                    },
                                ]}
                                numberOfLines={3}
                            >
                                {set_status_label()}
                            </Text>
                        </View>

                        <View style={Styles.blockDataCourse}>
                            <Text style={[Styles.titleCourse, !isMobile && { fontSize: 17 }]} numberOfLines={3}>
                                {item.title}
                            </Text>
                            {isMobile ? (
                                <RenderHTML
                                    source={{ html: item.description_short }}
                                    baseStyle={Styles.descriptionCourse}
                                    defaultTextProps={{ numberOfLines: 3, allowFontScaling: false }}
                                    contentWidth={winWidth}
                                />
                            ) : (
                                <RenderHTML
                                    source={{ html: item.description_short }}
                                    baseStyle={{
                                        fontSize: 16,
                                        fontWeight: 'normal',
                                        color: theme.colors.textSecondary,
                                        flex: 1,
                                    }}
                                    defaultTextProps={{ numberOfLines: 3, allowFontScaling: false }}
                                    contentWidth={winWidth}
                                />
                            )}
                            {/* Descripción larga removida en card para evitar layouts extensos y errores de estilos */}
                        </View>
                    </TouchableOpacity>
                </View>
            )
        } else {
            return (
                <View style={[{ opacity: STATUS === LEARNING_STATUS.BLOCKED ? 0.5 : 1 }, { marginRight: 16, marginLeft: 12 }]}>
                    <TouchableOpacity
                        onPress={handle_course}
                        style={[
                            {
                                flex: 1,
                            },
                            STATUS === LEARNING_STATUS.BLOCKED && Styles.block_content,
                            { flexDirection: 'row' },
                        ]}
                        disabled={STATUS === LEARNING_STATUS.BLOCKED ? true : false}
                    >
                        {/* Imagen */}
                        <View>
                            {contentDownloaded && (
                                <View style={Styles.containerCloudCheck}>
                                    <Image
                                        style={{ width: 24, height: 24 }}
                                        tintColor={theme.colors.colorApproved}
                                        source={require('../../../assets/cloudCheck.png')}
                                    />
                                </View>
                            )}
                            <Image
                                style={[Styles.imageCourse, { width: 280 }]}
                                source={{
                                    uri: item.cover_image
                                        ? item.cover_image
                                        : 'https://resources-one.s3.us-east-2.amazonaws.com/sky/contents/assets/faltante.png',
                                }}
                            />
                        </View>
                        {/* Info */}
                        <View style={{ marginLeft: 16, maxWidth: 200 }}>
                            <View>
                                <Text style={[Styles.titleCourse, { fontSize: 19, marginBottom: 6 }]} numberOfLines={3}>
                                    {item.title}
                                </Text>

                                <RenderHTML
                                    source={{ html: item.description_short }}
                                    baseStyle={{
                                        fontSize: 16,
                                        fontWeight: 'normal',
                                        color: theme.colors.textSecondary,
                                    }}
                                    defaultTextProps={{ numberOfLines: 3, allowFontScaling: false }}
                                    contentWidth={winWidth}
                                />
                            </View>
                            <View
                                style={[
                                    {
                                        marginTop: 12,
                                        paddingLeft: 5,
                                        paddingRight: 8,
                                        paddingVertical: 3,
                                        borderRadius: 5,
                                        borderWidth: 2,
                                        alignSelf: 'flex-start',
                                    },

                                    {
                                        backgroundColor:
                                            STATUS != LEARNING_STATUS.BLOCKED ? statusColors[STATUS] : 'transparent' || theme.colors.colorLocked,
                                        borderColor: STATUS === LEARNING_STATUS.BLOCKED ? theme.colors.colorLocked : 'transparent',
                                    },
                                ]}
                            >
                                <Text
                                    style={[
                                        Styles.statusModuleText,
                                        {
                                            color: STATUS === LEARNING_STATUS.BLOCKED ? theme.colors.colorLocked : 'white',
                                        },
                                    ]}
                                    numberOfLines={3}
                                >
                                    {set_status_label()}
                                </Text>
                            </View>
                        </View>
                    </TouchableOpacity>
                </View>
            )
        }
    } else {
        return (
            <View style={[Styles.containerList, { opacity: STATUS === LEARNING_STATUS.BLOCKED ? 0.5 : 1 }]}>
                <TouchableOpacity
                    onPress={handle_course}
                    style={[Styles.itemCourse, STATUS === LEARNING_STATUS.BLOCKED && Styles.block_content]}
                    disabled={STATUS === LEARNING_STATUS.BLOCKED ? true : false}
                >
                    <View style={[Styles.containerItemList, !isMobile && { flex: 1 }]}>
                        <Image
                            style={[Styles.imageCourseList, !isMobile && { width: 92, height: 92, marginRight: 12 }]}
                            source={{
                                uri: item.cover_image
                                    ? item.cover_image
                                    : 'https://resources-one.s3.us-east-2.amazonaws.com/sky/contents/assets/faltante.png',
                            }}
                        />
                        <View style={[Styles.blockDataCourseList, !isMobile && { flex: 1 }]}>
                            <Text style={[Styles.titleCourse, !isMobile && { fontSize: 17 }]} numberOfLines={2}>
                                {item.title}
                            </Text>
                            <RenderHTML
                                source={{ html: item.description_short }}
                                baseStyle={Styles.descriptionCourse}
                                defaultTextProps={{ numberOfLines: 2, ellipsizeMode: 'tail' }}
                                contentWidth={winWidth}
                            />

                            <View
                                style={[
                                    Styles.statusModuleList,
                                    {
                                        backgroundColor:
                                            STATUS != LEARNING_STATUS.BLOCKED ? statusColors[STATUS] : 'transparent' || theme.colors.colorLocked,
                                        borderColor: STATUS === LEARNING_STATUS.BLOCKED ? theme.colors.colorLocked : 'transparent',
                                    },
                                    !isMobile && { marginTop: 8 },
                                ]}
                            >
                                <Text
                                    style={[
                                        Styles.statusModuleText,
                                        {
                                            color: STATUS === LEARNING_STATUS.BLOCKED ? theme.colors.colorLocked : 'white',
                                        },
                                    ]}
                                    numberOfLines={2}
                                >
                                    {set_status_label()}
                                </Text>
                            </View>
                        </View>
                    </View>
                </TouchableOpacity>
                <View style={Styles.spacer}></View>
                <View style={Styles.spacer}></View>
            </View>
        )
    }
}
